import { getGroupType, shortHumanizer } from '@/utils';
import { Done as DoneIcon } from '@mui/icons-material';
import {
  alpha,
  Box,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import { useNichePrisoners } from './useNichePrisoners';
import { MaterialReactTable } from 'material-react-table';
import { format } from 'date-fns';

const prisonerColumns = [
  { header: 'Custody Suite', accessorKey: 'custodyUnitName' },
  { header: 'Custody Number', accessorKey: 'custodyNumber' },
  { header: 'Occurrence Number', accessorKey: 'occurrenceNumber' },
  { header: 'Forenames', accessorKey: 'forenames' },
  { header: 'Surname', accessorKey: 'surname' },
  { header: 'Arresting Officer', accessorKey: 'arrestingOfficer' },
  { header: 'Investigating Officer', accessorKey: 'investigatingOfficer' },
  { header: 'OIC', accessorKey: 'officerInCase' },
  { header: 'Team', accessorKey: 'officerInCaseTeam' },
  {
    header: 'Arrived',
    accessorKey: 'arrivalTime',
    Cell: ({ cell }) => format(cell.getValue(), 'dd/MM/yyyy HH:mm:ss'),
  },
  {
    header: 'Time in Custody',
    accessorKey: 'inCustodyDurationSeconds',
    Cell: ({ cell }) => shortHumanizer(cell.getValue() * 1000),
  },
  {
    header: 'Observation Level',
    accessorKey: 'observationLevelCode',
  },
  { header: 'Offence', accessorKey: 'offence', size: 200 },
];

export function Prisoners({ groupCodes, onComplete }) {
  const {
    query: { data: prisoners, isFetching, isLoading },
  } = useNichePrisoners(getGroupType('SECTOR'), groupCodes);

  function handleCompleteClick() {
    onComplete();
  }

  return (
    <Box sx={{ px: 1 }}>
      <Stack
        direction="row"
        spacing={1}
        sx={(theme) => ({
          alignItems: 'center',
          position: 'sticky',
          top: 48,
          backgroundColor: alpha(theme.palette.background.paper, 0.8),
          zIndex: 700,
          pl: 1,
          py: 1,
        })}
      >
        <Typography variant="h6">Prisoners</Typography>
        <Box>
          <Tooltip title="Done" placement="right">
            <IconButton onClick={handleCompleteClick}>
              <DoneIcon fontSize="inherit" />
            </IconButton>
          </Tooltip>
        </Box>
      </Stack>
      <Stack spacing={1} sx={{ pb: 1 }}>
        <MaterialReactTable
          muiTablePaperProps={{ variant: 'outlined', elevation: 0 }}
          defaultColumn={{ size: 0, enableEditing: false }}
          columns={prisonerColumns}
          data={prisoners ?? []}
          enableGrouping
          enableBottomToolbar={false}
          enableDensityToggle={false}
          enableFullScreenToggle={false}
          enablePagination={false}
          state={{ isLoading: isLoading || isFetching }}
          initialState={{
            density: 'compact',
            expanded: true,
            grouping: ['custodyUnitName'],
            sorting: [{ id: 'custodyNumber', desc: false }],
            columnVisibility: { remarks: false },
          }}
          muiTableBodyRowProps={{
            sx: { '&:last-child td, &:last-child th': { border: 0 } },
          }}
          muiSearchTextFieldProps={{ variant: 'outlined', size: 'small' }}
        />
      </Stack>
    </Box>
  );
}
